import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Sparkles, Users, Mail, Tags, QrCode, ShieldCheck } from 'lucide-react';
import api from '../lib/api';
import { useAuth } from '../contexts/AuthContext';
import { DEMO_TENANT_ID } from './DemoBanner';

export const WHATS_NEW = {
  version: '3.2.0',
  items: [
    { Icon: Users, title: 'Custom platform roles', text: 'Create your own staff roles with their own View and Manage permissions.' },
    { Icon: Mail, title: 'Staff invite emails', text: 'New staff get a secure link to set their own password, with a temporary password as backup.' },
    { Icon: Tags, title: 'Relabel queue', text: 'Print every pack that still shows an old long code in one batch.' },
    { Icon: QrCode, title: 'Short pack codes', text: 'Open-pack codes are now 9 characters or fewer, matching the QR label.' },
    { Icon: ShieldCheck, title: 'Controlled-drug register', text: 'Print or download the register with pharmacist sign-off.' },
  ],
};

export const WhatsNewDialog = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!user?.user_id || user.tenant_id === DEMO_TENANT_ID || user.whats_new_seen === WHATS_NEW.version) return undefined;
    const t = setInterval(() => {
      if (!document.querySelector('[role="dialog"], [role="alertdialog"]')) { setOpen(true); clearInterval(t); }
    }, 1500);
    return () => clearInterval(t);
  }, [user?.user_id, user?.tenant_id, user?.whats_new_seen]);
  const dismiss = () => {
    setOpen(false);
    api.post('/auth/whats-new-seen', { version: WHATS_NEW.version }).catch(() => {});
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && dismiss()}>
      <DialogContent className="max-w-md" data-testid="whats-new-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Sparkles className="h-5 w-5 text-primary" />What's new in {WHATS_NEW.version}</DialogTitle>
        </DialogHeader>
        <ul className="space-y-3">
          {WHATS_NEW.items.map(({ Icon, title, text }, i) => (
            <li key={title} className="flex gap-3 animate-in fade-in slide-in-from-bottom-1" style={{ animationDelay: `${i * 60}ms` }}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary"><Icon className="h-3.5 w-3.5" /></span>
              <div><p className="text-sm font-medium">{title}</p><p className="text-xs text-muted-foreground">{text}</p></div>
            </li>
          ))}
        </ul>
        <DialogFooter><Button onClick={dismiss} className="w-full" data-testid="whats-new-dismiss">Got it</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
